<div class="withdrawal-notification">
  <img [src]="'/assets/images/wdl-' + activeStepContent.key + '.png'" alt="Notification capture" />
  @if (currentWdlStep === steps.UPDATE_NOTIFICATION) {
    <h1 class="ds-heading-1">{{ 'ACCOUNT.withdrawalV2.emotionalization.'+  activeStepContent.key +'.introHeading' | translate }}</h1>
    <p class="ds-ui-2 ds-color-core-neutral-8">{{ 'ACCOUNT.withdrawalV2.emotionalization.'+  activeStepContent.key +'.introDescription' | translate }}</p>
  }

  <div class="withdrawal-header">
    <h1 class="ds-heading-1">{{ 'ACCOUNT.withdrawalV2.emotionalization.' + activeStepContent.key + '.heading' | translate }}</h1>
    <p class="ds-ui-2 ds-color-core-neutral-8">{{ 'ACCOUNT.withdrawalV2.emotionalization.' + activeStepContent.key + '.description' | translate }}</p>
  </div>

  <div class="withdrawal-topics">
    @for (topic of activeStepContent.topics; track topic) {
      <div class="withdrawal-topic">
        <div>
          <app-ds-rounded-icon [variant]="activeStepContent.iconVariant" [icon]="topic.icon"></app-ds-rounded-icon>
        </div>
        <div>
          <h2 class="ds-heading-2">{{
            'ACCOUNT.withdrawalV2.emotionalization.' + activeStepContent.key + '.' + topic.key + '.title' | translate
          }}</h2>
          <p class="ds-ui-3 ds-color-core-neutral-8">{{
            'ACCOUNT.withdrawalV2.emotionalization.' + activeStepContent.key + '.' + topic.key + '.description' | translate
          }}</p>
        </div>
      </div>
    }
  </div>

  <p class="ds-ui-2 ds-color-core-neutral-8" [innerHTML]="'ACCOUNT.withdrawalV2.emotionalization.' + activeStepContent.key + '.summary' | translate">
  </p>

  <div class="withdrawal-buttons" [class.mobile-buttons]="isMobileApp" [ngStyle]="{ display: isMobileApp ? 'block' : 'flex' }">
    <app-ds-button variant="primary" size="default" (clicked)="onCancelWithdrawal()"
      >{{ 'ACCOUNT.withdrawalV2.emotionalization.' + activeStepContent.key + '.buttonStay' | translate }}
    </app-ds-button>
    <app-ds-button variant="primary" size="default" (clicked)="onContinue()"
      >{{ 'ACCOUNT.withdrawalV2.emotionalization.' + activeStepContent.key + '.buttonContinue' | translate }}
    </app-ds-button>
  </div>
</div>
